var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-btn",on:{"click":_vm.linkToAI}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-content"},[_c('img',{attrs:{"src":require("@/assets/images/kf-robot.png"),"alt":""}}),_c('span',{staticStyle:{"font-size":"0.7rem"}},[_vm._v("智能客服")])])
}]

export { render, staticRenderFns }